'use strict';

angular.module('TurneroApp').service('derivacionService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Derivacion/:id', { id: '@Id_Domicilio' }, {
        Get_Tipos_Derivacion_Combo: {
            method: 'GET',
            params: {
                id_turno: '@id_turno'
            },
            url: portal.getUrlServer() + 'api/Derivacion/Get_Tipos_Derivacion_Combo/'
        },
        Get_Agendas_Derivacion_Combo: {
            method: 'GET',
            params: {
                id_agenda: '@id_agenda'
            },
            url: portal.getUrlServer() + 'api/Derivacion/Get_Agendas_Derivacion_Combo/',

        },
        Get_Puestos_Derivacion_Combo: {
            method: 'GET',
            params: {
                id_agenda: '@id_agenda',
                id_usuario_sesion: '@id_usuario_sesion'
            },
            url: portal.getUrlServer() + 'api/Derivacion/Get_Puestos_Derivacion_Combo/',

        },
        Get_Grupos_Derivacion_Combo: {
            method: 'GET',
            params: {
                id_agenda: '@id_agenda'
            },
            url: portal.getUrlServer() + 'api/Derivacion/Get_Grupos_Derivacion_Combo/',

        },
        Post_Derivar_Turno_Atencion: {
            method: 'POST',
            params: {
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/Derivacion/Post_Derivar_Turno_Atencion/',

        },
        Get_Tramites_Derivacion_Combo: {
            method: 'GET',
            params: {
                id_centro_atencion: '@id_centro_atencion',
            },
            url: portal.getUrlServer() + 'api/Derivacion/Get_Tramites_Derivacion_Combo/',

        },
        Get_Agendas_X_Tramite_Derivacion_Combo: {
            method: 'GET',
            params: {
                id_centro_atencion: '@id_centro_atencion',
                id_tramite: '@id_tramite',
            },
            url: portal.getUrlServer() + 'api/Derivacion/Get_Agendas_X_Tramite_Derivacion_Combo/',

        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/general/derivacion-service.js